module.exports = __webpack_public_path__ + "static/media/19.37497590.webp";